import { render } from "./expertJoin.vue?vue&type=template&id=a4032c60&scoped=true"
import script from "./expertJoin.vue?vue&type=script&lang=js"
export * from "./expertJoin.vue?vue&type=script&lang=js"

import "./expertJoin.vue?vue&type=style&index=0&id=a4032c60&lang=scss&scoped=true"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4032c60"]])

export default __exports__